import { axios } from '@/lib/axios';

export const readNotifications = (id: string) => {
  const payload = {
    id: id,
  };
  return axios.post('/customer-api/read-notifications', payload);
};
